import axios from "axios";
import { Dispatch } from "redux";

import { PLOT_FAIL, PLOT_LOADING, PLOT_SUCCESS, PlotDispatchTypes, PLOT_EDIT } from './plotActionTypes';


export const fetchPlot = ( payload: any ) => async ( dispatch: Dispatch< PlotDispatchTypes > ) => {

    try {

        dispatch( { 
        
            type: PLOT_LOADING
        
        } );

        const tokenConfig1 = {
            // "x-auth-token": localStorage.getItem("token"),
            headers: {
                accept: "/*/",
                Authorization: "Bearer " + localStorage.getItem("shreeDevToken"),
            },
        };
        
        axios.get( 'https://shreee-development-test.herokuapp.com/admin/all-properties', tokenConfig1 )
        .then( ( res: any ) => { 

            console.log( 'res: in plot ', res );
            dispatch( { 

                type: PLOT_SUCCESS,
                payload: res.data.data

            } );

        } )
        .catch( ( e: any ) => { 

            console.log( 'in err: ', e );
            dispatch( { 

                type: PLOT_FAIL,
                payload: e.response.data.msg

            } );
        } )
        

    }
    catch( e ) {
        console.log( 'error occured', e );
        dispatch( {

            type: PLOT_FAIL,
            payload: 'Some unknown Error'
        
        } )
    }

}

export const saveEditData = ( payload: any ) => async ( dispatch: Dispatch< PlotDispatchTypes > ) => {
    console.log( 'inside saveEditData ', payload );
    try {
        dispatch( { 

            type: PLOT_EDIT,
            payload: payload
    
        } );
    
    }
    catch( e ) {
        console.log( e );
    }

}

